import React from "react"
import PropTypes from "prop-types"
import trackCustomEventTrigger from "utils/trackCustomEventTrigger"
import trackingCategoriesHelper from "utils/trackingCategoriesHelper"

import {
  StyledDropdownWrapper,
  StyledDropdownLabel,
  StyledSelectedValue,
  StyledIcon,
} from "./Dropdown.styles"

const Dropdown = ({
  options,
  onChange,
  label,
  defaultValue,
  direction,
  ...rest
}) => {
  const handleSelected = (option) => {
    onChange(option)
    trackCustomEventTrigger({
      category: trackingCategoriesHelper.PORTFOLIO_FILTER,
      action: "Click",
      label: `${trackingCategoriesHelper.PORTFOLIO_FILTER}(${option.label})`,
    })
  }
  return (
    <StyledDropdownWrapper
      {...rest}
      data-direction={direction}
      data-testid="selectMenu"
    >
      <StyledIcon icon="chevronDown" aria-hidden="true" />
      <StyledDropdownLabel>{label}</StyledDropdownLabel>
      <StyledSelectedValue
        as="select"
        aria-label={rest["aria-label"] || label || "Filter options"}
        value={String(defaultValue.value)}
        onChange={(event) => {
          const option = options.find(
            (item) => String(item.value) === event.target.value
          )
          if (option) handleSelected(option)
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={String(option.value)}>
            {option.label}
          </option>
        ))}
      </StyledSelectedValue>
    </StyledDropdownWrapper>
  )
}
Dropdown.propTypes = {
  label: PropTypes.node,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.node,
    })
  ).isRequired,
  defaultValue: PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.node,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  direction: PropTypes.string,
}

Dropdown.defaultProps = {
  label: null,
  direction: "top",
}
export default Dropdown
